package com.veldekar.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.`data`.add
import com.varabyte.kobweb.core.`init`.InitRoute
import com.varabyte.kobweb.core.`init`.InitRouteContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.ArrowDownIcon
import com.varabyte.kobweb.silk.components.icons.ArrowUpIcon
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.veldekar.HeadlineTextStyle
import com.veldekar.components.layouts.PageLayout
import com.veldekar.components.layouts.PageLayoutData
import com.veldekar.components.srd.spells.BlessDescription
import com.veldekar.components.srd.spells.BlessMetadata
import com.veldekar.components.srd.spells.CalmEmotionsDescription
import com.veldekar.components.srd.spells.CalmEmotionsMetadata
import com.veldekar.components.srd.spells.ChainLightningDescription
import com.veldekar.components.srd.spells.ChainLightningMetadata
import com.veldekar.components.srd.spells.CommandDescription
import com.veldekar.components.srd.spells.CommandMetadata
import com.veldekar.components.srd.spells.ComprehendLanguagesDescription
import com.veldekar.components.srd.spells.ComprehendLanguagesMetadata
import com.veldekar.components.srd.spells.ConeOfColdDescription
import com.veldekar.components.srd.spells.ConeOfColdMetadata
import com.veldekar.components.srd.spells.CounterspellDescription
import com.veldekar.components.srd.spells.CounterspellMetadata
import com.veldekar.components.srd.spells.CreateFoodAndWaterDescription
import com.veldekar.components.srd.spells.CreateFoodAndWaterMetadata
import com.veldekar.components.srd.spells.DarknessDescription
import com.veldekar.components.srd.spells.DarknessMetadata
import com.veldekar.components.srd.spells.FireballDescription
import com.veldekar.components.srd.spells.FireballMetadata
import com.veldekar.components.srd.spells.HasteDescription
import com.veldekar.components.srd.spells.HasteMetadata
import com.veldekar.components.srd.spells.HeatMetalDescription
import com.veldekar.components.srd.spells.HeatMetalMetadata
import com.veldekar.components.srd.spells.HoldPersonDescription
import com.veldekar.components.srd.spells.HoldPersonMetadata
import com.veldekar.components.srd.spells.IceStormDescription
import com.veldekar.components.srd.spells.IceStormMetadata
import com.veldekar.components.srd.spells.MagnificentMansionDescription
import com.veldekar.components.srd.spells.MagnificentMansionMetadata
import com.veldekar.components.srd.spells.PolymorphDescription
import com.veldekar.components.srd.spells.PolymorphMetadata
import com.veldekar.components.srd.spells.PrestidigitationDescription
import com.veldekar.components.srd.spells.PrestidigitationMetadata
import com.veldekar.components.srd.spells.ScorchingRayDescription
import com.veldekar.components.srd.spells.ScorchingRayMetadata
import com.veldekar.components.srd.spells.ScryingDescription
import com.veldekar.components.srd.spells.ScryingMetadata
import com.veldekar.components.srd.spells.SendingDescription
import com.veldekar.components.srd.spells.SendingMetadata
import com.veldekar.components.srd.spells.TeleportationCircleDescription
import com.veldekar.components.srd.spells.TeleportationCircleMetadata
import com.veldekar.components.srd.spells.TinyHutDescription
import com.veldekar.components.srd.spells.TinyHutMetadata
import com.veldekar.components.srd.spells.WallOfFireDescription
import com.veldekar.components.srd.spells.WallOfFireMetadata
import com.veldekar.components.srd.spells.WindWalkDescription
import com.veldekar.components.srd.spells.WindWalkMetadata
import com.veldekar.toSitePalette
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.Unit
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1

@InitRoute
public fun initSpellsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(
        title = "Spells",
        ogTitle = "Veldekar - Spells",
        ogDescription = "Spells of Veldekar — custom campaign lore, favorite spells of the heroes, and 5e SRD spell reference.",
        ogImage = "ai/spells_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "The spellcasters of Veldekar unleashing signature spells side-by-side",
        includeSrdAttribution = true
    ))
}

@Page(routeOverride = "spells")
@Composable
public fun SpellsPage() {
    val ctx = rememberPageContext()
    val allIndices = setOf("bless", "calm-emotions", "chain-lightning", "command", "comprehend-languages", "cone-of-cold", "counterspell", "create-food-and-water", "darkness", "fireball", "haste", "heat-metal", "hold-person", "ice-storm", "magnificent-mansion", "polymorph", "prestidigitation", "scorching-ray", "scrying", "sending", "teleportation-circle", "tiny-hut", "wall-of-fire", "wind-walk")
    var expandedSpells by remember { mutableStateOf(setOf<String>()) }
    PageLayout(ctx) {
        Column(Modifier.fillMaxWidth().padding(topBottom = 2.cssRem).gap(2.cssRem)) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                H1(HeadlineTextStyle.toModifier().toAttrs()) { SpanText("Spells") }
                Button(onClick = { if (expandedSpells.size == allIndices.size) expandedSpells = emptySet() else expandedSpells = allIndices }) {
                    SpanText(if (expandedSpells.size == allIndices.size) "Collapse All" else "Expand All")
                }
            }
            Column(Modifier.fillMaxWidth().gap(1.cssRem)) {
                SpellItem(
                    name = "Bless",
                    subtitle = "1st-level Enchantment",
                    veldekar = "Falorn blesses his allies.",
                    image = "",
                    index = "bless",
                    expanded = expandedSpells.contains("bless"),
                    onToggle = {
                        if (expandedSpells.contains("bless")) {
                            expandedSpells = expandedSpells.filter { it != "bless" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "bless"
                        }
                    }
                    ,
                    metadata = { BlessMetadata() }
                ) {
                    BlessDescription()
                }
                SpellItem(
                    name = "Calm Emotions",
                    subtitle = "2nd-level Enchantment",
                    veldekar = "Caper once freed Bigglesworth from the Aboleth's enslavement with Calm Emotions.",
                    image = "",
                    index = "calm-emotions",
                    expanded = expandedSpells.contains("calm-emotions"),
                    onToggle = {
                        if (expandedSpells.contains("calm-emotions")) {
                            expandedSpells = expandedSpells.filter { it != "calm-emotions" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "calm-emotions"
                        }
                    }
                    ,
                    metadata = { CalmEmotionsMetadata() }
                ) {
                    CalmEmotionsDescription()
                }
                SpellItem(
                    name = "Chain Lightning",
                    subtitle = "6th-level Evocation",
                    veldekar = "Powerful and destructive spell in Dirk's arsenal.",
                    image = "",
                    index = "chain-lightning",
                    expanded = expandedSpells.contains("chain-lightning"),
                    onToggle = {
                        if (expandedSpells.contains("chain-lightning")) {
                            expandedSpells = expandedSpells.filter { it != "chain-lightning" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "chain-lightning"
                        }
                    }
                    ,
                    metadata = { ChainLightningMetadata() }
                ) {
                    ChainLightningDescription()
                }
                SpellItem(
                    name = "Command",
                    subtitle = "1st-level Enchantment",
                    veldekar = "Enemies try to cast this, but the heroes always counter spell it, lol.",
                    image = "",
                    index = "command",
                    expanded = expandedSpells.contains("command"),
                    onToggle = {
                        if (expandedSpells.contains("command")) {
                            expandedSpells = expandedSpells.filter { it != "command" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "command"
                        }
                    }
                    ,
                    metadata = { CommandMetadata() }
                ) {
                    CommandDescription()
                }
                SpellItem(
                    name = "Comprehend Languages",
                    subtitle = "1st-level Divination",
                    veldekar = "Tuesday uses this to anticipate attacks and solve puzzles.",
                    image = "",
                    index = "comprehend-languages",
                    expanded = expandedSpells.contains("comprehend-languages"),
                    onToggle = {
                        if (expandedSpells.contains("comprehend-languages")) {
                            expandedSpells = expandedSpells.filter { it != "comprehend-languages" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "comprehend-languages"
                        }
                    }
                    ,
                    metadata = { ComprehendLanguagesMetadata() }
                ) {
                    ComprehendLanguagesDescription()
                }
                SpellItem(
                    name = "Cone of Cold",
                    subtitle = "5th-level Evocation",
                    veldekar = "Dirk slaughtered Ludwig Voss's goons with this spell.",
                    image = "",
                    index = "cone-of-cold",
                    expanded = expandedSpells.contains("cone-of-cold"),
                    onToggle = {
                        if (expandedSpells.contains("cone-of-cold")) {
                            expandedSpells = expandedSpells.filter { it != "cone-of-cold" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "cone-of-cold"
                        }
                    }
                    ,
                    metadata = { ConeOfColdMetadata() }
                ) {
                    ConeOfColdDescription()
                }
                SpellItem(
                    name = "Counterspell",
                    subtitle = "3rd-level Abjuration",
                    veldekar = "Favorite of the heroes, bane of villains and DMs everywhere. Tuesday, Dirk and Caper.",
                    image = "",
                    index = "counterspell",
                    expanded = expandedSpells.contains("counterspell"),
                    onToggle = {
                        if (expandedSpells.contains("counterspell")) {
                            expandedSpells = expandedSpells.filter { it != "counterspell" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "counterspell"
                        }
                    }
                    ,
                    metadata = { CounterspellMetadata() }
                ) {
                    CounterspellDescription()
                }
                SpellItem(
                    name = "Create Food and Water",
                    subtitle = "3rd-level Conjuration",
                    veldekar = "Falorn tortures his friends with Oatmeal.",
                    image = "",
                    index = "create-food-and-water",
                    expanded = expandedSpells.contains("create-food-and-water"),
                    onToggle = {
                        if (expandedSpells.contains("create-food-and-water")) {
                            expandedSpells = expandedSpells.filter { it != "create-food-and-water" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "create-food-and-water"
                        }
                    }
                    ,
                    metadata = { CreateFoodAndWaterMetadata() }
                ) {
                    CreateFoodAndWaterDescription()
                }
                SpellItem(
                    name = "Darkness",
                    subtitle = "2nd-level Evocation",
                    veldekar = "According to Prudence's Barrowmen, Verudis Pent's personal guard may use Darkness or something similar.",
                    image = "",
                    index = "darkness",
                    expanded = expandedSpells.contains("darkness"),
                    onToggle = {
                        if (expandedSpells.contains("darkness")) {
                            expandedSpells = expandedSpells.filter { it != "darkness" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "darkness"
                        }
                    }
                    ,
                    metadata = { DarknessMetadata() }
                ) {
                    DarknessDescription()
                }
                SpellItem(
                    name = "Fireball",
                    subtitle = "3rd-level Evocation",
                    veldekar = "A favorite of Tuesday, Dirk, and Annette. You may not even see Tuesday (he’s flying high above you) and your spell resistance is no match for his metamagics.",
                    image = "images/mushroomCloud.webp",
                    imageWidth = 1_315,
                    imageHeight = 1_068,
                    index = "fireball",
                    expanded = expandedSpells.contains("fireball"),
                    onToggle = {
                        if (expandedSpells.contains("fireball")) {
                            expandedSpells = expandedSpells.filter { it != "fireball" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "fireball"
                        }
                    }
                    ,
                    metadata = { FireballMetadata() }
                ) {
                    FireballDescription()
                }
                SpellItem(
                    name = "Haste",
                    subtitle = "3rd-level Transmutation",
                    veldekar = "Bigglesworth and Caper charge quickly into battle thanks to Tuesday and Annette's haste spells. Tuesday sometimes twin casts this spell.",
                    image = "",
                    index = "haste",
                    expanded = expandedSpells.contains("haste"),
                    onToggle = {
                        if (expandedSpells.contains("haste")) {
                            expandedSpells = expandedSpells.filter { it != "haste" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "haste"
                        }
                    }
                    ,
                    metadata = { HasteMetadata() }
                ) {
                    HasteDescription()
                }
                SpellItem(
                    name = "Heat Metal",
                    subtitle = "2nd-level Transmutation",
                    veldekar = "A devious spell used by Annette when she's not hastening Bigglesworth.",
                    image = "",
                    index = "heat-metal",
                    expanded = expandedSpells.contains("heat-metal"),
                    onToggle = {
                        if (expandedSpells.contains("heat-metal")) {
                            expandedSpells = expandedSpells.filter { it != "heat-metal" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "heat-metal"
                        }
                    }
                    ,
                    metadata = { HeatMetalMetadata() }
                ) {
                    HeatMetalDescription()
                }
                SpellItem(
                    name = "Hold Person",
                    subtitle = "2nd-level Enchantment",
                    veldekar = "Falorn apprehended the villainous Ludwig Voss with this spell.",
                    image = "",
                    index = "hold-person",
                    expanded = expandedSpells.contains("hold-person"),
                    onToggle = {
                        if (expandedSpells.contains("hold-person")) {
                            expandedSpells = expandedSpells.filter { it != "hold-person" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "hold-person"
                        }
                    }
                    ,
                    metadata = { HoldPersonMetadata() }
                ) {
                    HoldPersonDescription()
                }
                SpellItem(
                    name = "Ice Storm",
                    subtitle = "4th-level Evocation",
                    veldekar = "Not as dangerous as 3 inches of snow on Glenwood Avenue, but still a powerful spell in the right hands.",
                    image = "",
                    index = "ice-storm",
                    expanded = expandedSpells.contains("ice-storm"),
                    onToggle = {
                        if (expandedSpells.contains("ice-storm")) {
                            expandedSpells = expandedSpells.filter { it != "ice-storm" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "ice-storm"
                        }
                    }
                    ,
                    metadata = { IceStormMetadata() }
                ) {
                    IceStormDescription()
                }
                SpellItem(
                    name = "Magnificent Mansion",
                    subtitle = "7th-level Conjuration",
                    veldekar = "The heroes now have a place to crash after a long day of adventuring, and it's all thanks to Dirk's Magnificent Mansion spell.",
                    image = "",
                    index = "magnificent-mansion",
                    expanded = expandedSpells.contains("magnificent-mansion"),
                    onToggle = {
                        if (expandedSpells.contains("magnificent-mansion")) {
                            expandedSpells = expandedSpells.filter { it != "magnificent-mansion" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "magnificent-mansion"
                        }
                    }
                    ,
                    metadata = { MagnificentMansionMetadata() }
                ) {
                    MagnificentMansionDescription()
                }
                SpellItem(
                    name = "Polymorph",
                    subtitle = "4th-level Transmutation",
                    veldekar = "Tuesday's favorite spell. Turns friends into T-Rex, Giant Ape, or Giant Fruit Bat. Ludwig Voss was turned into a quokka.",
                    image = "images/quokkaInHandcuffs_transparent.webp",
                    imageWidth = 816,
                    imageHeight = 1_080,
                    index = "polymorph",
                    expanded = expandedSpells.contains("polymorph"),
                    onToggle = {
                        if (expandedSpells.contains("polymorph")) {
                            expandedSpells = expandedSpells.filter { it != "polymorph" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "polymorph"
                        }
                    }
                    ,
                    metadata = { PolymorphMetadata() }
                ) {
                    PolymorphDescription()
                }
                SpellItem(
                    name = "Prestidigitation",
                    subtitle = "Transmutation cantrip",
                    veldekar = "The only way the heroes can stomach Falorn's cooking.",
                    image = "",
                    index = "prestidigitation",
                    expanded = expandedSpells.contains("prestidigitation"),
                    onToggle = {
                        if (expandedSpells.contains("prestidigitation")) {
                            expandedSpells = expandedSpells.filter { it != "prestidigitation" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "prestidigitation"
                        }
                    }
                    ,
                    metadata = { PrestidigitationMetadata() }
                ) {
                    PrestidigitationDescription()
                }
                SpellItem(
                    name = "Scorching Ray",
                    subtitle = "2nd-level Evocation",
                    veldekar = "Annette's go-to spell. She stores charges of it, so she can cast without using a spell slot.",
                    image = "",
                    index = "scorching-ray",
                    expanded = expandedSpells.contains("scorching-ray"),
                    onToggle = {
                        if (expandedSpells.contains("scorching-ray")) {
                            expandedSpells = expandedSpells.filter { it != "scorching-ray" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "scorching-ray"
                        }
                    }
                    ,
                    metadata = { ScorchingRayMetadata() }
                ) {
                    ScorchingRayDescription()
                }
                SpellItem(
                    name = "Scrying",
                    subtitle = "5th-level Divination",
                    veldekar = "The heroes can scry shards of the Shield of Concar. Annette has a magical Spyglass of Scrying.",
                    image = "",
                    index = "scrying",
                    expanded = expandedSpells.contains("scrying"),
                    onToggle = {
                        if (expandedSpells.contains("scrying")) {
                            expandedSpells = expandedSpells.filter { it != "scrying" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "scrying"
                        }
                    }
                    ,
                    metadata = { ScryingMetadata() }
                ) {
                    ScryingDescription()
                }
                SpellItem(
                    name = "Sending",
                    subtitle = "3rd-level Evocation",
                    veldekar = "Never announce your travel to the Powerglow Guild. Keep them on their toes.",
                    image = "",
                    index = "sending",
                    expanded = expandedSpells.contains("sending"),
                    onToggle = {
                        if (expandedSpells.contains("sending")) {
                            expandedSpells = expandedSpells.filter { it != "sending" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "sending"
                        }
                    }
                    ,
                    metadata = { SendingMetadata() }
                ) {
                    SendingDescription()
                }
                SpellItem(
                    name = "Teleportation Circle",
                    subtitle = "5th-level Conjuration",
                    veldekar = "Tuesday transports the group across Veldekar with this spell.",
                    image = "",
                    index = "teleportation-circle",
                    expanded = expandedSpells.contains("teleportation-circle"),
                    onToggle = {
                        if (expandedSpells.contains("teleportation-circle")) {
                            expandedSpells = expandedSpells.filter { it != "teleportation-circle" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "teleportation-circle"
                        }
                    }
                    ,
                    metadata = { TeleportationCircleMetadata() }
                ) {
                    TeleportationCircleDescription()
                }
                SpellItem(
                    name = "Tiny Hut",
                    subtitle = "3rd-level Evocation",
                    veldekar = "Dirk's refuge from the elements before he learned Magnificent Mansion.",
                    image = "",
                    index = "tiny-hut",
                    expanded = expandedSpells.contains("tiny-hut"),
                    onToggle = {
                        if (expandedSpells.contains("tiny-hut")) {
                            expandedSpells = expandedSpells.filter { it != "tiny-hut" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "tiny-hut"
                        }
                    }
                    ,
                    metadata = { TinyHutMetadata() }
                ) {
                    TinyHutDescription()
                }
                SpellItem(
                    name = "Wall of Fire",
                    subtitle = "4th-level Evocation",
                    veldekar = "Previously Dirk's go-to spell for area control. Now he knows more powerful spells.",
                    image = "",
                    index = "wall-of-fire",
                    expanded = expandedSpells.contains("wall-of-fire"),
                    onToggle = {
                        if (expandedSpells.contains("wall-of-fire")) {
                            expandedSpells = expandedSpells.filter { it != "wall-of-fire" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "wall-of-fire"
                        }
                    }
                    ,
                    metadata = { WallOfFireMetadata() }
                ) {
                    WallOfFireDescription()
                }
                SpellItem(
                    name = "Wind Walk",
                    subtitle = "6th-level Transmutation",
                    veldekar = "Korvis enabled the heroes to travel vast distances across Veldekar with this spell. Or even just across town in Freeburg.",
                    image = "",
                    index = "wind-walk",
                    expanded = expandedSpells.contains("wind-walk"),
                    onToggle = {
                        if (expandedSpells.contains("wind-walk")) {
                            expandedSpells = expandedSpells.filter { it != "wind-walk" }.toSet()
                        } else {
                            expandedSpells = expandedSpells + "wind-walk"
                        }
                    }
                    ,
                    metadata = { WindWalkMetadata() }
                ) {
                    WindWalkDescription()
                }
            }
        }
    }
}

@Composable
public fun SpellItem(
    name: String,
    subtitle: String,
    veldekar: String,
    image: String,
    imageWidth: Int? = null,
    imageHeight: Int? = null,
    index: String,
    expanded: Boolean,
    onToggle: () -> Unit,
    metadata: @Composable () -> Unit,
    content: @Composable () -> Unit,
) {
    val palette = ColorMode.current.toSitePalette()
    Column(Modifier.fillMaxWidth().backgroundColor(palette.nearBackground).borderRadius(8.px).padding(1.cssRem).gap(1.cssRem)) {
        Row(Modifier.fillMaxWidth().cursor(Cursor.Pointer).onClick { onToggle() }, verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween) {
            Row(Modifier.gap(1.cssRem).flexGrow(1f), verticalAlignment = Alignment.CenterVertically) {
                if (image.isNotEmpty()) {
                    Image(if (image.startsWith("/")) image else "/" + image, width = imageWidth, height = imageHeight, modifier = Modifier.width(4.cssRem).height(auto).borderRadius(4.px).objectFit(ObjectFit.Contain).flexShrink(0f))
                }
                Column(Modifier.gap(0.25.cssRem).flexGrow(1f)) {
                    Link("/spell-" + index, modifier = Modifier.onClick { it.stopPropagation() }) {
                        val nameSize = if (expanded) 2.cssRem else 1.2.cssRem
                        SpanText(name, Modifier.fontSize(nameSize).fontWeight(700))
                    }
                    if (expanded) SpanText(subtitle, Modifier.fontStyle(FontStyle.Italic).fontSize(0.9.cssRem))
                    SpanText(veldekar, Modifier.fontSize(0.9.cssRem))
                }
            }
            if (expanded) ArrowUpIcon() else ArrowDownIcon()
        }
        if (expanded) {
            Column(Modifier.fillMaxWidth().padding(top = 1.cssRem)) {
                Column(Modifier.fillMaxWidth().gap(0.75.cssRem)) {
                    metadata()
                    Column(Modifier.fillMaxWidth().padding(top = 0.5.cssRem)) {
                        content()
                    }
                }
            }
        }
    }
}
